/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-12 17:34:44
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-21 12:26:04
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorHomepage/RouteBlock/index.tsx
 */

import React from 'react';

import { useSelector } from 'react-redux';
import { getI18nFromGeneral } from '@/src/tools/tools';
import _RouteBlock from 'src/constrains/RouterBlock/RouterBlock';

const RouteBlock = (props) => {
  const { getHasModified } = props;
  const hasModified = useSelector(getHasModified());

  return (
    <_RouteBlock
      onConfirm={(f) => f()}
      okText={getI18nFromGeneral('general.commonHeader.discard_text')}
      active={hasModified}
      title={getI18nFromGeneral('general.commonHeader.discard_header')}
      content={getI18nFromGeneral('general.commonHeader.discard_content')}
    />
  );
};
export default RouteBlock;
